export default __webpack_public_path__ + "static/media/single-project-page-05-img-02.cf54c448.jpg";